import React, { useState, useEffect } from 'react';
import { auth } from '../utils/firebase';
import { signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { toast } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { User } from 'lucide-react';

const Header = () => {
  const [user] = useAuthState(auth);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  // Add listener for window resize to handle responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success('Successfully logged out');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Error logging out');
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-12">
          <div className="flex items-center">
            <div className="h-8 w-8 bg-gradient-to-tr from-blue-500 to-cyan-400 rounded-full flex items-center justify-center shadow-sm">
              <img
                src="/oil.png"
                alt="OilTank.App"
                className="h-5 w-5 brightness-0 invert"
              />
            </div>
            <h1 className="text-xl font-semibold ml-3 bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent font-['Inter'] tracking-tight">OilTank.App</h1>
          </div>
          
          <div className="flex items-center space-x-4">
            {user && (
              <>
                <Link 
                  to="/profile" 
                  className="flex items-center gap-2 text-slate-600 hover:text-slate-800"
                  title="User Profile"
                >
                  <User className="h-5 w-5 text-blue-500" />
                  {!isMobile && (
                    <span className="text-sm">
                      {user?.displayName || user?.email}
                    </span>
                  )}
                </Link>
                <div className="h-4 w-px bg-slate-200" />
              </>
            )}
            {user && (
              <button
                onClick={handleLogout}
                className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-slate-700 bg-slate-100 hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              >
                Logout
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 